<template>
    <div class="page" :class="{isPhonePage: isPhone}">
        <div class="base" id="ID30">
            <h2>相信自己的选择，一定没错</h2>
            <h4></h4>
            <h3>咨询热线  4001363622</h3>
            <ul>
                <li>
                    <img src="http://img.cdboost.cn/cdboost/sy/gzh.jpg" alt="">
                    <p>关注公众号</p>
                </li>
                <li>
                    <img src="http://img.cdboost.cn/cdboost/sy/wx.png" alt="">
                    <p>扫一扫,了解更多</p>
                </li>
            </ul>
        </div>
        <div class="base" id="ID31">
            <div class="title-box">
                <span class="title">项目优势</span>
            </div>
            <div class="content">
                <img src="http://img.cdboost.cn/cdboost/sy/cop2.png" alt="">
                <ul>
                    <li v-for="(item, index) in list2" :class="'li' + index">
                        <template v-if="index < 3">
                            <div class="title" :style="{color: item.color}">{{item.title}}</div>
                            <div class="text">{{item.text}}</div>
                        </template>
                        <template v-else>
                            <div class="text">{{item.text}}</div>
                            <div class="title" :style="{color: item.color}">{{item.title}}</div>
                        </template>
                    </li>
                </ul>
            </div>
        </div>
        <div class="base" id="ID32">
            <div class="title-box">
                <span class="title">新能源汽车充电市场前景</span>
            </div>
            <p class="top" style="color: #2765AD;">截止2020 年我国私用充电桩数量达到 87.4 万个。</p>
            <p>随着新能源汽车的渗透率不断提高，保守估计2025年渗透率提升至<span>35.0%</span> ，车桩比例为<span>2.5</span>，
                至2025年私用充电桩保有量约为<span>691万个</span>。若新能源车渗透率到2025年达到<span>50%</span>，车桩比下降至<span>2.0</span>，
                如2025年私用充电桩保有量有望达到<span>1133万个</span>(数据来自互联网)。</p>
            <img src="http://img.cdboost.cn/cdboost/sy/cop31.png" alt="">
        </div>
        <div class="base" id="ID35">
            <div class="title-box">
                <span class="title">电动自行车市场前景</span>
            </div>
            <p class="top" style="color: #2765AD;">目前全国电瓶车保有量已超过3亿辆，且每年都在持续增加。电瓶车充电随即成为高频刚需。为保障充电安全，智能充电桩将是社区、园区和写字楼首选，带来庞大的市场需求。</p>
            <p>据统计，近年来中国电动自行车年销量超过<span>3003万</span>辆 ，2021年我国电动车自行车产量增长至<span>3903万</span>辆，
                截止2021年7月20日，全部发生电动车自行车火灾<span>6452</span>起。<span>80%</span>的电动车自行车火灾发生在充申过程。
                火灾发生<span>3分30秒</span>，温度可达<span>120OC</span>!有效管控充电过程，能极大降低火灾事故的发生</p>
            <div class="content">
                <div class="leftCon">
                    <div class="li">
                        <img src="http://img.cdboost.cn/cdboost/sy/cop411.png" alt="">
                        <p>2021年1月23日早上，广西南宁市凤岭山语城电动自行车棚突然起火</p>
                    </div>
                    <div class="li">
                        <img src="http://img.cdboost.cn/cdboost/sy/cop422.png" alt="">
                        <p>2021年6月23日凌晨，四川成都一小区电动自行车棚起火</p>
                    </div>
                </div>
                <div class="rightCon">
                    <img src="http://img.cdboost.cn/cdboost/sy/cop42.png" alt="">
                    <div class="li0">公安部发布 <br/><span>《关于规范电动车停放充电加强火灾防范的通告》《关于加强低速电动车管理的通知》</span><br/>
                        强调严禁在建筑内的 &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 共用走道、楼梯间、安全出&nbsp;&nbsp;口处等公共区域停放电动车或为电动车充电</div>
                    <div class="li1">国务院应急管理部发布<br/><span>《高层居民建筑消防安全管理规定》</span>禁止在高层民用建筑公共门厅、疏散走道、楼梯间、安全出口停放电动自行车或者为电动自行车充电</div>
                    <div class="li2">公安部下发<br/><span>《关于加强居民区电动车火灾防范工作的通知》</span></div>
                    <div class="li3">公安部、国务院应急管理部联合发布<br/><span>《关于进一步加强电动车自行车消防安全管理通知》</span></div>
                </div>
            </div>
        </div>
        <div class="base" id="ID33">
            <div class="title-box">
                <span class="title">合作模式</span>
            </div>
            <ul>
                <li v-for="(item, index) in list1" :class="'li' + index">
                    <div class="title">{{item.title}}</div>
                    <div class="text">{{item.text}}</div>
                </li>
            </ul>
        </div>
        <div class="base" id="ID34">
            <div class="title-box">
                <span class="title">合作伙伴</span>
            </div>
            <img src="http://img.cdboost.cn/cdboost/sy/copicons.png" alt="">
        </div>
    </div>
</template>

<script>
    import {getPCorPhone} from "../tools";

    export default {
        name: "service",
        data(){
            return {
                isPhone: false,
                list1: [
                    {title: '品牌代理', text: '方案支持 / 培训支持 / 售后支持运营服务'},
                    {title: 'OEM定制', text: '丝印定制 / 硬件结构'},
                    {title: '技术服务', text: '技术支持 / 平台开放 / 业务对接'},
                ],
                list2: [
                    {color: '#9D66AA', title: '市场竞争格局尚未形成', text: '目前市场并无独角兽企业，占领绝对市场份额，绝对强势的竞争格局尚未产生。存在很大的市场空间。'},
                    {color: '#F9B11F', title: '政策扶持', text: '社区电动自行车无监控充电安全隐患太大， 大多数火灾都是充电不安全造成， 社区管理与消防都在要求监管充电过程'},
                    {color: '#F87703', title: '投资回报率高', text: '社区充电投资少，汇报快。并能够实现以项目养项目'},
                    {color: '#3272B7', title: '解决充电隐患', text: '提升充电体验，降低充电隐患。'},
                    {color: '#8AB847', title: '巨大市场规模', text: '全国电瓶车保有量已超过3亿辆,新能源汽车保有量700万辆，且每年都在持续增加。充电随即成为高频刚需。市场规模庞大。'},
                    {color: '#C8202F', title: '提升社区品质，业主方驱动力强', text: '智能充电完善社区的配套设施，提升社区的品质，为社区添光增彩。'},
                ]
            }
        },
        created() {
            this.isPhone = getPCorPhone();
        }
    }
</script>

<style scoped  lang="scss">
    .base {
        color: #333333;
        position: relative;
        overflow: hidden;
        background: white;
    }
    #ID31{
        .content{
            position: relative;
            padding-top: 8em;
            text-align: center;
            li{
                width: 15em;
                text-align: center;
                line-height: 1.5;
                position: absolute;
                .title{
                    font-size: 1.4em;
                }
                .text{
                    text-align: left;
                }
            }
            .li0{
                left: 7%;
                top: 33%;
            }
            .li1{
                left: 7%;
                top: 54%;
            }
            .li2{
                left: 7%;
                top: 77%;
            }
            .li3{
                right: 4%;
                top: 36%;
            }
            .li4{
                right: 4%;
                top: 51%;
            }
            .li5{
                right: -1%;
                top: 78%;
                width: 20em;
            }
            img{
                width: 100%;
            }
        }
    }
    #ID32, #ID35{
        background-color: #E0E8EF;
        p{
            text-indent: 2em;
            line-height: 2;
            padding: 0 3em;
            font-size: 1.5em;
            span{
                color: #2765AD;
            }
        }
        .top{
            margin-top: 6em;
        }
        img{
            padding: 2em 5em;
            width: calc(100% - 10em);
        }
    }
    #ID35{
        background-color: white;
        .content{
            display: flex;
            .leftCon{
                padding-top: 7em;
                width: 35%;
                .li{
                    display: flex;
                    align-items: flex-start;
                    background-color: #E0E8EF;
                    border-radius: 0.5em;
                    margin: 0 0 1em 4em;
                    width: 100%;
                }
                p{
                    padding: 2em 0.5em 0 0;
                    text-indent: 0;
                }
                img{
                    width: 20em;
                    height: 13em;
                    padding: 1em;
                }
            }
            .rightCon{
                text-align: center;
                width: 65%;
                position: relative;
                div{
                    position: absolute;
                    width: 13em;
                    font-size: 1.5em;
                    line-height: 1.5;
                }
                .li0{
                    left: 7%;
                    top: 13%;
                    text-align: left;
                }
                .li1{
                    left: 10%;
                    bottom: 5%;
                    width: 16em;
                    text-align: left;
                }
                .li2{
                    right: 13%;
                    top: 6%;
                    width: 16em;
                    text-align: center;
                }
                .li3{
                    right: 3%;
                    top: 38%;
                    width: 16em;
                    text-align: center;
                }
                img{
                    width: 38em;
                    padding: 0;
                }
                span{
                    color: #2765AD;
                }
            }
        }
    }
    #ID30{
        background-image: url("http://img.cdboost.cn/cdboost/sy/cop1.png");
        width: 100%;
        background-size: 100% 100%;
        height: 50em;
        color: white;
        position: relative;
        ul{
            background-color: #244465;
            display: flex;
            width: 34em;
            justify-content: space-around;
            text-align: center;
            padding: 1em 0;
            position: absolute;
            bottom: 4em;
            left: 6%;
            p{
                line-height: 1;
                padding-top: 0.5em;
                font-size: 0.9em;
            }
            img{
                width: 12em;
                height: 12em;
            }
        }
        h2{
            font-size: 4em;
            position: absolute;
            left: 4%;
            bottom: 60%;
        }
        h4{
            position: absolute;
            left: 4%;
            bottom: 57%;
            width: 52em;
            height: 1px;
            background-color: white;
        }
        h3{
            font-size: 4em;
            position: absolute;
            left: 4%;
            bottom: 45%;
        }
    }
    #ID33{
        background-color: #ECEBF4;
        ul{
            padding-top: 10em;
            height: 40em;
            margin: 8em 0em 5em 0em;
            width: calc(100% - 0em);
            background-size: 100% 100%;
            background-image: url("http://img.cdboost.cn/cdboost/sy/cop5.png");
            position: relative;
            .title{
                font-size: 2em;
                color: white;
                background: linear-gradient(90deg, #5EA8DC 14.000000000000002%, #337BC7 77%);
                border-radius: 0.5em;
                height: 2.5em;
                line-height: 2.5em;
                width: 100%;
                text-align: center;
            }
            .text{
                color: #337BC7;
                font-size: 1.5em;
                width: 100%;
                text-align: center;
                margin-top: 2em;
            }
            li{
                top: 33em;
                width: 21em;
                position: absolute;
            }
            .li0{
                left: 7%;
            }
            .li1{
                left: 39%;
            }
            .li2{
                left: 71%;
            }
        }
    }
    #ID34{
        background-image: url("http://img.cdboost.cn/cdboost/sy/copbackground.png");
        height: 60em;
        background-size: 100% 100%;
        img{
            margin: 0 5.5em;
            padding-top: 11em;
            width: calc(100% - 11em);
        }
    }
    .isPhonePage{
        .title-box{
            font-size: 3.5rem;
            padding-top: 1rem;
        }
        #ID31{
            li{
                width: 30em;
                text-align: center;
                line-height: 1;
                position: absolute;
                .title{
                    font-size: 9px;
                }
                .text{
                    font-size: 8px;
                    text-align: left;
                }
            }
            .li0{
                left: 1%;
                top: 33%;
            }
            .li1{
                left: 1%;
                top: 54%;
            }
            .li2{
                left: 1%;
                top: 77%;
            }
            .li3{
                right: 1%;
                top: 30%;
                width: 25em;
            }
            .li4{
                right: 0%;
                top: 47%;
                width: 26em;
                .title{
                    font-size: 8px;
                }
                .text{
                    font-size: 7px;
                    text-align: left;
                }
            }
            .li5{
                right: 1%;
                top: 70%;
                width: 25em;
            }
            img{
                width: 90%;
            }
        }
        #ID32, #ID35{
            .top{
                margin-top: 2em;
            }
            p{
                font-size: 12px;
                padding: 0 5px;
            }
        }
        #ID35{
            .content{
                .leftCon{
                    padding-top: 7em;
                    .li{
                        display: block;
                        background-color: #E0E8EF;
                        border-radius: 0.5em;
                        margin: 0 0 1em 4em;
                        width: 100%;
                    }
                    p{
                        padding: 5px 0.5em 0 0;
                        line-height: 1;
                    }
                    img{
                        width: calc(100% - 2em);
                        height: 25em;
                        padding: 1em;
                    }
                }
                .rightCon{
                    text-align: center;
                    width: 65%;
                    position: relative;
                    div{
                        position: absolute;
                        width: 13em;
                        font-size: 1.5em;
                        line-height: 1.5;
                    }
                    .li0{
                        left: 7%;
                        top: 13%;
                        text-align: left;
                    }
                    .li1{
                        left: 18%;
                        bottom: 5%;
                        width: 16em;
                        text-align: left;
                    }
                    .li2{
                        right: 13%;
                        top: 2%;
                        width: 16em;
                        text-align: center;
                    }
                    .li3{
                        right: 3%;
                        top: 31%;
                        width: 16em;
                        text-align: center;
                    }
                    img{
                        width: 38em;
                        height: 100%;
                        padding: 0;
                    }
                    span{
                        color: #2765AD;
                    }
                }
            }
        }
    }
</style>